class NfeRateioFreteModal {
    static get $inject() {
        return ['$scope']
    }

    constructor($scope) {
        this.apply = fn => $scope.$apply(fn)
    }

    $onInit() {
        this.cte = this.resolve.cte
    }
}

angular.module('eficienciaFiscalModule')
    .component('nfeRateioFreteModal', {
        controller: NfeRateioFreteModal,
        bindings: {
            close: '&',
            resolve: '<'
        },

        template: `
        <modal modal-title="Rateio da CT-e" close="$ctrl.close">
        <modal-body>                                
            <div>
                <highlighted>
                    <main>
                        NF-es que possuem rateio da CT-e nº <b>{{$ctrl.cte.numero}}</b>.
                    </main>
                </highlighted>
                <table class="table no-margin">
                    <thead>
                        <tr>
                            <th>Chave NF-e</th>
                            <th>Base de cálculo do ICMS</th>
                            <th>Valor do ICMS</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr ng-repeat="nfe in $ctrl.cte.nfes">
                            <td>{{nfe.chave}}</td>
                            <td class="text-right">{{nfe.frete.freteCte.valorBaseCalculo}}</td>
                            <td class="text-right">{{nfe.frete.freteCte.valorIcms}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </modal-body>

        <modal-footer>
            <button class="btn btn-default" ng-click="$ctrl.close()">Fechar</button>
        </modal-footer>
    </modal>
        `
    })
